import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { SharedModule as PrimeNGSharedModule } from 'primeng/api';
import { SharedModule as AppSharedModule } from '../shared/shared.module';

import { RulesComponent } from './rules.component';

@NgModule({
  declarations: [RulesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    PaginatorModule,
    SidebarModule,
    ButtonModule,
    InputTextModule,
    CheckboxModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    FileUploadModule,
    TooltipModule,
    ConfirmDialogModule,
    PrimeNGSharedModule,
    AppSharedModule,
  ],
  exports: [RulesComponent],
  providers: [ConfirmationService],
})
export class RulesModule {}
